import React from "react";
import { Text, type TextProps, StyleSheet } from "react-native";

import { useTheme } from "@/hooks/useTheme";

export type ThemedTextProps = TextProps & {
  type?: "default" | "title" | "defaultSemiBold" | "subtitle" | "link" | "thin" | "small";
};

export const ThemedText = React.forwardRef<Text, ThemedTextProps>(({ style, type = "default", ...rest }, ref) => {
  const { colors } = useTheme();
  return (
    <Text
      ref={ref}
      style={[
        { color: colors.text, borderColor: colors.border },
        type === "default" ? styles.default : undefined,
        type === "title" ? styles.title : undefined,
        type === "defaultSemiBold" ? styles.defaultSemiBold : undefined,
        type === "subtitle" ? styles.subtitle : undefined,
        type === "link" ? [styles.link, { $$css: true, _: "link" } as any] : undefined,
        type === "thin" ? styles.thin : undefined,
        type === "small" ? styles.small : undefined,
        style,
      ]}
      {...rest}
    />
  );
});

ThemedText.displayName = "ThemedText";

const styles = StyleSheet.create({
  default: {
    fontSize: 16,
    lineHeight: 24,
  },
  defaultSemiBold: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: "600",
  },
  title: {
    fontSize: 32,
    fontWeight: "bold",
    lineHeight: 32,
  },
  subtitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  link: {
    lineHeight: 30,
    fontSize: 16,
    color: "#0a7ea4",
  },
  thin: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: "thin",
  },
  small: {
    fontSize: 14,
    lineHeight: 24,
    fontWeight: "thin",
  },
});
